'use strict';

var toastr = require('toastr');
var ConfigurationMarketAssignController = function ConfigurationMarketAssignController($scope, dataRetrieverService, marketAssignService, staticDataService, $log) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', 'configuration-market-assign-mode').setCustomSearchCriteriaRules([]);
  function successSavingHandler() {
    $scope.$broadcast('configuration-market-assign:saveSuccess');
    toastr.success('Data was saved successfully');
    staticDataService.loadMarkets(true);
  }
  function errorSavingHandler(error) {
    var message = error.data && error.data.message || error.statusText || error.message;
    $log.error('ConfigurationMarketAssignController: errorSavingHandler - ' + message);
    toastr.error(message);
  }
  $scope.save = function (event, rows) {
    marketAssignService.save(rows).then(successSavingHandler, errorSavingHandler);
  };
};
ConfigurationMarketAssignController.$inject = ['$scope', 'DataRetrieverService', 'ConfigurationMarketAssignService', 'StaticDataService', '$log'];
module.exports = ConfigurationMarketAssignController;